export default function PHP_is_array() {
  return (
    <div>
      <h1>PHP_is_array</h1>
    </div>
  );
}
